import store from '../store/configureStore'

export default (prefix) => {
  const {
    unidadesUsuario: { codigoUsuario }
  } = store.getState()
  return `${prefix}_${codigoUsuario}`
}
